import {mapGetters} from "vuex";

export const ROLE_LANDLORD = 1;
export const ROLE_TENANT = 2;
export const ROLE_AGENT = 3;
export const ROLE_APPROVING_LANDLORD = 4;

export const SENT_TO_LANDLORD = 10;
export const SENT_TO_TENANT = 20;

export const SIGNED_BY_LANDLORD = 100;
export const SIGNED_BY_TENANT = 200;

export const APPROVED = 1000;

export default {
    computed: {
        ...mapGetters(['myId', 'getAccountEmail'])
    },
    methods: {
        getContractStatusSet(customContract)
        {
            let set = [];

            let isLandlord = true;

            // Role filling

            if(_.filter(customContract.tenants, {'id' : this.myId}).length > 0) {
                set.push(ROLE_TENANT);
                isLandlord = false;
            }

            if (isLandlord
                && customContract.is_created_by_broker
                && (
                    this.myId !== customContract.landlord_id
                    && this.getAccountEmail !== customContract.landlord_email
                )
                && this.myId === customContract.user_id) {
                set.push(ROLE_AGENT);
            }

            if (isLandlord
                && customContract.is_created_by_broker
                && (
                    this.myId === customContract.landlord_id
                    || this.getAccountEmail === customContract.landlord_email
                )) {
                set.push(ROLE_APPROVING_LANDLORD);
            }

            if (isLandlord && !customContract.is_created_by_broker) {
                set.push(ROLE_LANDLORD);
            }

            // Sent status filling

            if (customContract.tenants.length > 0 && _.filter(customContract.tenants, {'is_sent': true}).length === customContract.tenants.length) {
                set.push(SENT_TO_TENANT)
            }

            if (customContract.requires_landlord_approval && customContract.is_landlord_approval_requested) {
                set.push(SENT_TO_LANDLORD)
            }

            // Approve status

            if (customContract.requires_landlord_approval && customContract.is_approved_by_landlord) {
                set.push(APPROVED)
            }

            // Sign Status

            if (_.filter(customContract.tenants, {'is_signed': true}).length === customContract.tenants.length) {
                if(customContract.has_extra_tenant_signature) {
                    if(customContract.is_signed_by_extra_tenant) {
                        set.push(SIGNED_BY_TENANT)
                    }
                } else {
                    set.push(SIGNED_BY_TENANT)
                }
            }

            if (customContract.is_signed_by_landlord) {
                set.push(SIGNED_BY_LANDLORD)
            }

            return set;
        },
        getContractStatusText(customContract) {
            let status = this.getContractStatusSet(customContract);

            if (status.includes(SIGNED_BY_TENANT) && status.includes(SIGNED_BY_LANDLORD)) {
                //return 'Completed';
                return 'properties.table.contracts.completed';
            }

            if (status.includes(ROLE_TENANT)) {
                // Viewer is a tenant

                if (status.includes(SIGNED_BY_TENANT) && !status.includes(SIGNED_BY_LANDLORD)) {
                    return 'properties.table.contracts.awaitinglandlordsignature';
                }

                if (!status.includes(SIGNED_BY_TENANT) && !status.includes(SIGNED_BY_LANDLORD)) {
                    return 'properties.table.contracts.ready';
                }
            }

            if (status.includes(ROLE_AGENT)) {

                // Viewer is broker for this contract
                if (!status.includes(SENT_TO_LANDLORD)) {
                    return 'properties.table.contracts.inprogress'
                }

                if (status.includes(SENT_TO_LANDLORD) && !status.includes(APPROVED)) {
                    return 'properties.table.contracts.awaitingapproval'
                }

                if (status.includes(SENT_TO_LANDLORD) && status.includes(APPROVED) && !status.includes(SIGNED_BY_TENANT)) {
                    return 'properties.table.contracts.approvednotsentforsignature'
                }

                if (status.includes(SENT_TO_TENANT) && !status.includes(SIGNED_BY_TENANT)) {
                    return 'properties.table.contracts.awaitingtenantsignature'
                }

                if (status.includes(SENT_TO_TENANT) && status.includes(SIGNED_BY_TENANT)) {
                    return 'properties.table.contracts.ready'
                }
            }

            if (status.includes(ROLE_LANDLORD)) {

                // Viewer is a landlord

                if (!status.includes(SENT_TO_TENANT)) {
                    return 'properties.table.contracts.inprogress';
                }

                if (status.includes(SENT_TO_TENANT) && !status.includes(SIGNED_BY_TENANT)) {
                    return 'properties.table.contracts.awaitingtenantsignature';
                }

                if (status.includes(SENT_TO_TENANT) && status.includes(SIGNED_BY_TENANT)) {
                    return 'properties.table.contracts.ready';
                }

            }

            if (status.includes(ROLE_APPROVING_LANDLORD)) {

                if (status.includes(SENT_TO_LANDLORD) && !status.includes(APPROVED)) {
                    return 'properties.table.contracts.awaitingapproval'
                }

                // Viewer is approving landlord
                return 'properties.table.contracts.inprogress';
            }
        },

        approve() {
            this.state = 'saving';

            axios({
                method: 'PUT',
                url: `${window.config.apiUrl}api/custom-contract/${this.customContract.id}/approve`,
                cancelToken: window.AuthorizationCancelSource.token
            }).then(response => {
                this.$router.push('/contracts');
                this.$store.commit('setSuccessBarMessage', 'Contract has been approved');
            }).finally(() => {
                this.state = 'ready';
            });
        },
        disapprove() {
            this.state = 'saving';

            axios({
                method: 'PUT',
                url: `${window.config.apiUrl}api/custom-contract/${this.customContract.id}/disapprove`,
                cancelToken: window.AuthorizationCancelSource.token
            }).then(response => {
                this.$router.push('/contracts');
                this.$store.commit('setSuccessBarMessage', 'Contract has been disapproved');
            }).finally(() => {
                this.state = 'ready';
            });
        },
        revoke() {
            if (!confirm('Do you want to revoke the contract?')) {
                return;
            }

            this.state = 'saving';

            axios({
                method: 'PUT',
                url: `${window.config.apiUrl}api/custom-contract/${this.customContract.id}/revoke`,
                cancelToken: window.AuthorizationCancelSource.token
            }).then(response => {
                this.$router.push('/contracts');
                this.$store.commit('setSuccessBarMessage', this.$t('successbar.label.revoked'));
            }).finally(() => {
                this.state = 'ready';
            });
        },
        destroy() {
            this.state = 'saving';

            axios({
                method: 'DELETE',
                url: `${window.config.apiUrl}api/custom-contract/${this.customContract.id}`,
                cancelToken: window.AuthorizationCancelSource.token,
            }).then(response => {
                this.$store.commit('setSuccessBarMessage', this.$t('digital-contract.contract-deleted.label'));
                this.$router.push('/contracts');
            }).finally(() => {
                this.state = 'ready';
            });
        },
    }
}
